import { ANALYTICS_URL } from '@/core/config';

/**
 * Общее для контроллеров сервиса ECASH Analytics (перемещения, казначейские лимиты).
 * Сервис отдельный от бэка ECASH, но принимает тот же токен — его подставляет `server`.
 */

/** Конфиг запроса: адрес сервиса и без общего снекбара — ошибки показывают сами страницы */
export const analyticsConfig = (extra: Record<string, unknown> = {}) => ({
    baseURL: ANALYTICS_URL,
    silentError: true,
    ...extra,
});

/** `?a=1&b=2` из набора параметров; пустые значения пропускаются, без параметров — пустая строка */
export const analyticsQuery = (params: Record<string, string | number | boolean | null | undefined>): string => {
    const qs = new URLSearchParams();

    Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '' && v !== false) {
            qs.set(k, String(v));
        }
    });
    const str = qs.toString();

    return str ? `?${str}` : '';
};

interface ErrorLike {
    message?: string;
    response?: { status?: number; data?: { detail?: unknown; error?: string; message?: string; Message?: string } };
}

/** Текст ошибки сервера для показа: `detail` (строка или список pydantic), `error`, message, затем статус */
export const analyticsErrorText = (e: unknown): string => {
    const err = (e ?? {}) as ErrorLike;
    const data = err.response?.data;
    const detail = data?.detail;

    if (typeof detail === 'string' && detail) {
        return detail;
    }

    if (Array.isArray(detail) && detail.length > 0) {
        return detail.map((d: { msg?: string } | string) => (typeof d === 'string' ? d : d?.msg) || String(d)).join('; ');
    }

    return data?.error || data?.message || data?.Message || err.message || (err.response?.status ? `HTTP ${err.response.status}` : 'Ошибка запроса');
};
